module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "indexChartBar"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-24da0b14"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexPage/IndexBarChart.vue
// module id = 1888
// module chunks = 1